import { render, staticRenderFns } from "./CreateCaseStudy.vue?vue&type=template&id=a2a6a6c6"
import script from "./CreateCaseStudy.vue?vue&type=script&lang=js"
export * from "./CreateCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./CreateCaseStudy.vue?vue&type=style&index=0&id=a2a6a6c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports